var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
var FormButtonComponent = /** @class */ (function (_super) {
    __extends(FormButtonComponent, _super);
    function FormButtonComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        return _this;
    }
    FormButtonComponent.prototype.ngOnInit = function () {
        // super.ngOnInit();
    };
    FormButtonComponent.prototype.ngOnChanges = function (changes) {
        // super.ngOnChanges(changes);
        if (changes.col) {
            this.setBtn();
        }
    };
    FormButtonComponent.prototype.setBtn = function () {
        if (this.col.params && this.col.params.button) {
            this.btn = this.col.params.button;
            this.btn.type = this.btn.type || 'button';
        }
        if (this.key === 'listrow') {
            $.extend(true, this.btn, { params: { btnClass: { xs: true } } });
        }
    };
    FormButtonComponent.prototype.onClick = function (e) {
        e.stopPropagation();
        _super.prototype.onClick.call(this, this.btn.event, this.btn.type);
    };
    FormButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-button',
                    template: '<button [type]="btn.type" [disabled]="btn.disabled" (click)="onClick($event)" [key]="\'btn\'" [btn]="btn" buttonDir>{{ btn.caption }}</button>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    FormButtonComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return FormButtonComponent;
}(ColumnBaseComponent));
export { FormButtonComponent };
//# sourceMappingURL=button.component.js.map